import { HttpHeaders } from '@angular/common/http';

export enum httpStatus {
	success = 'success',
	error = 'error'
}

export const httpHeaders = new HttpHeaders ({'Content-Type': 'application/x-www-form-urlencoded' })